import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Stepper, { Step, StepLabel, StepContent } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';
import Input, { InputLabel } from 'material-ui/Input';
import { MenuItem } from 'material-ui/Menu';
import { FormControl, FormHelperText } from 'material-ui/Form';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import Select from 'material-ui/Select';

let id = 0;
function createData(rating, userbase) {
  id += 1;
  return { id, rating, userbase};
}

const data = [
  createData(7.0, 3008),
  createData(8.0, 1322),
  createData(8.5, 706),
  createData(9.0, 471),
  createData(9.5, 170),
  createData(10.0, 53),
];

class Q2 extends Component {

  constructor(props){
    super(props);

    this.state = {
      lowest: 7,
      highest: 10,
    };
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render(){
    const { classes, theme, location } = this.props;

    return(
      <div className={classes.root}>
        <Typography>We have divided our users with the following ratings:</Typography>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell className={classes.alignment} numeric>Rating</TableCell>
              <TableCell className={classes.alignment} numeric>Users Available</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.reverse().map(n => {
              return (
                <TableRow key={n.id}>
                  <TableCell className={classes.alignment}>{n.rating}</TableCell>
                  <TableCell className={classes.alignment} numeric>{n.userbase}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        <div className={classes.buttonNext}>
          <Button raised onClick={() => this.props.changeRoute("/console/display/adhoc_filters/question2")} color="primary" align="center" className={classes.button}>Go Back</Button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Q2)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/Adhoc/scenes/Distribution/Q2/index.js